<template>
  <div
  class="drop-list-item"
  :style="[true ? 'max-width: 160px':'']">
    <v-card
      class="pa-1 rounded-card"
      style="margin-bottom: 21px;"
      :class="card.locationType"
      hover
    >
      <v-row v-if="location != null" no-gutters>
        <v-col cols="8" class="text-left">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on" class="dropCardTitle overflowEllipsis">{{location.organization.name}}</span>
            </template>
            <span>{{location.organization.name}}</span>
          </v-tooltip>
          <br>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on" class="dropCardSubTitle overflowEllipsis">{{location.address | AddressObjectToString([['street', 'streetNo'], 'postalCode', ['city', 'countryCode']])}}</span>
            </template>
            <span>{{location.address | AddressObjectToString([['street', 'streetNo'], 'postalCode', ['city', 'countryCode']])}}</span>
          </v-tooltip>
        </v-col>
        <v-col  cols="4" class="text-left">
          <v-row class="fill-height" align="center" >
            <v-col v-if="drop.type === 'LocationPickup'" cols="12" class="text-center">
              <span class="dropCardSubTitle pickup"><span class="dropCardIcon pickup"><v-icon style="font-size: 12px;">fas fa-arrow-right</v-icon></span>{{drop.count}}</span>
            </v-col>
            <v-col v-if="drop.type === 'LocationDelivery'" cols="12" class="text-center">
              <span class="dropCardSubTitle delivery"><span class="dropCardIcon delivery"><v-icon style="font-size: 12px;">fas fa-arrow-left</v-icon></span>{{drop.count}}</span>
            </v-col>
            <v-col v-if="drop.type === 'Depot'" cols="12" class="text-center">
              <span class="dropCardSubTitle depot"><span class="dropCardIcon depot"><v-icon style="font-size: 12px;">fas fa-lock</v-icon></span>{{$t('fleet.depot')}}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row
        v-else
        class="text-center"
        no-gutters
      >
        <v-col cols="12" class="pa-1">
          <v-progress-circular
            size="20"
            width="3"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-col>
      </v-row>
    </v-card>
    <!-- <div v-if="locationIndex >= 0" style="opacity: 0; background-color: transparent;" :key="`calculation_${locationIndex}`" class="filtered">
      300km
    </div> -->
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'DropLocationItem',
  props: {
    locationID: String,
    card: Object,
    locationIndex: Number
  },
  methods: {
    ...mapActions({
      setPlannerDepotLocation: 'setPlannerDepotLocation'
    }),
  },
  computed: {
    ...mapGetters([
      'getPlannerLocationByID',
      'getPlannerDropsByArrayIDs'
    ]),
    location () {
      const fetchLocation = this.getPlannerLocationByID(this.locationID)
      return Object.keys(fetchLocation).length > 0 ? fetchLocation : null
    },
    drop () {
      let count = 0
      const fetchDrops = this.getPlannerDropsByArrayIDs(this.card.dropIDs)
      fetchDrops.forEach(({ unitsCount }) => {
        if (unitsCount != null) {
          Object.keys(unitsCount).forEach((key) => {
            count += unitsCount[key].count
          })
        } else {
          count += 0
        }
      })
      return { type: this.card.locationType, count }
    },
    randomBorderColor: () => {
      let key = Math.floor(Math.random() * 2)
      switch (key) {
        case 0:
          return 'departure'
        case 1:
          return 'arrival'
        default:
          return 'departure'
      }
    }
  },
  watch: {
    location: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (val == null && oldVal == null) {
          this.setPlannerDepotLocation({ locationID: this.locationID })
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .drop-list-item {
    font-size: 11px;
  }
  .Depot{
    background-color: #ebebeb !important;
    pointer-events: none;
  }
  .borderLeft {
    border-left: 5px solid;
    &.departure {
      border-left-color: #028489;
    }
    &.arrival {
      border-left-color: #890702;
    }
  }
  .dropCardTitle {
    &.overflowEllipsis {
      max-width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      display: inline-block;
    }
    font-size: 12px;
    font-weight: bold;
    color: #212121;
  }
  .dropCardSubTitle {
    &.pickup {
      color: #028489;
    }
    &.delivery {
      color: #890702;
    }
    &.depot {
      color: #484848;
    }
    &.overflowEllipsis {
      max-width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      display: inline-block;
    }
    display: inline-block;
    font-size: 10px;
    font-weight: bold;
    color: #777777
  }
  .dropCardIcon {
    &.pickup {
      i {
        color: #028489;
      }
    }
    &.delivery {
      i {
        color: #890702;
      }
    }
    &.depot {
      i {
        color: #484848;
      }
    }
    font-size: 12px;
    margin: 5px;
  }
  .dropCardIconValues {
    position: relative;
    top: -2px;
    left: -2px;
  }
</style>
